var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('NotificationCenter',{staticClass:"tw-fixed tw-bottom-2 tw-right-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }